'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var _require2 = require('buffer'),
    Buffer = _require2.Buffer;

var configure = require('../lib/configure');

var toFormData = require('../lib/buffer-to-form-data');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj, options) {
      var tmpObj, buf, searchParams, _yield$ky$post$json, Hash;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              tmpObj = {
                Data: null,
                Links: []
              };

              if (!Buffer.isBuffer(obj)) {
                _context.next = 6;
                break;
              }

              if (!options.enc) {
                tmpObj = {
                  Data: obj.toString(),
                  Links: []
                };
              }

              _context.next = 16;
              break;

            case 6:
              if (!DAGNode.isDAGNode(obj)) {
                _context.next = 10;
                break;
              }

              tmpObj = {
                Data: obj.Data.toString(),
                Links: obj.Links.map(function (l) {
                  return {
                    Name: l.Name,
                    Hash: l.Hash.toString(),
                    Size: l.Tsize
                  };
                })
              };
              _context.next = 16;
              break;

            case 10:
              if (!(typeof obj === 'object')) {
                _context.next = 15;
                break;
              }

              tmpObj.Data = obj.Data.toString();
              tmpObj.Links = obj.Links;
              _context.next = 16;
              break;

            case 15:
              throw new Error('obj not recognized');

            case 16:
              if (Buffer.isBuffer(obj) && options.enc) {
                buf = obj;
              } else {
                buf = Buffer.from(JSON.stringify(tmpObj));
              }

              searchParams = new URLSearchParams(options.searchParams);
              if (options.enc) searchParams.set('inputenc', options.enc);
              if (options.pin != null) searchParams.set('pin', options.pin);
              if (options.quiet != null) searchParams.set('quiet', options.quiet);
              _context.next = 23;
              return ky.post('object/put', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams,
                body: toFormData(buf)
              }).json();

            case 23:
              _yield$ky$post$json = _context.sent;
              Hash = _yield$ky$post$json.Hash;
              return _context.abrupt("return", new CID(Hash));

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
});